export const nav = 1;

export default {
  ["promo-sheet-manager"]: {
    nav,
    icon: "money",
    url: "/promo-sheet-manager",
    title: "Promo Sheets",
    templateProvider: $stateParams => `<promo-sheet-manager />`
  }
};
